/* casam-club-start.js — the 12-month club's choices on every cart line (DRM-2261, P-DRM-57).

   Mike, 11/3 on his phone: a Quick add put the club in his cart without "When should it start?". Only the club
   page's form (snippets/casam-club-options.liquid) posts properties[Start]; search and grid Quick add, the drawer's
   AI picks, HP quick view and the concierge each post the bare SOM12PRE variant through their own /cart/add.js
   call, so the line and the order carried no start choice. Mike, same day: the gift box starts checked, and one
   club per order, because each club ships to the one address on its order (a 2x buy put two of each blend in one
   box every month, to one person).

   1. On fetch, like the BYO default in casam-cart.js (one guard at the transport covers every present and future
      add path), a JSON club add:
        * gets the page's own defaults when it lacks a Start: Start "Now", Gift "Yes", _club "12mo". A line that
          already says when to start keeps everything it says;
        * is one club: quantity 1, and not added at all when the cart already holds one;
        * opens the cart drawer, so the shopper sees the choices and the one-per-order line.
      Non-JSON bodies (the page's own form) pass through untouched and are trimmed afterwards (3). Any throw falls
      through to the untouched request.
   2. The cart line's choices (snippets/casam-club-start.liquid) rewrite the line through /cart/change.js, which
      replaces a line's properties wholesale, so the line is read back from /cart.js and only the choice changes.
      Unticking the gift drops Gift, Gift for and Gift message together, as the page's form does.
   3. More than one club in the cart (the page's form adding a second, a /cart/add link with a quantity) is trimmed
      to the newest line at quantity 1 in one /cart/update.js call.
   theme.CartForm rebuilds the drawer and /cart on cart:build.

   The values are the page's, word for word: the spine's club schedule (club_boxes.start_choice, gift_choice) reads
   them. The club variant comes from window.CASAM_CART.clubVid (cart-drawer.liquid, resolved by SKU); without it this
   file does nothing. */
(function(){
  var CFG=window.CASAM_CART||{};
  var VID=CFG.clubVid;
  if(!VID)return;
  var orig=(typeof window.fetch==='function')?window.fetch:null;
  if(!orig)return;

  function isClub(id){return String(id)===String(VID);}
  function getCart(){return orig.call(window,'/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();});}
  function clubLines(cart){return (cart&&cart.items||[]).filter(function(it){return isClub(it.variant_id);});}
  function rebuild(open){
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    /* after theme.CartForm has redrawn the line */
    if(open)setTimeout(function(){document.dispatchEvent(new CustomEvent('cart:open'));},700);
  }
  function patchLine(line){
    if(!line.properties||typeof line.properties!=='object')line.properties={};
    var p=line.properties;
    if(!p.Start){p.Start='Now';if(!p.Gift)p.Gift='Yes';}
    if(!p._club)p._club='12mo';
    line.quantity=1;
  }
  function okResponse(body){
    return new Response(JSON.stringify(body||{}),{status:200,headers:{'Content-Type':'application/json'}});
  }

  var trimming=false;
  function trimToOne(){
    if(trimming)return Promise.resolve(false);
    trimming=true;
    return getCart().then(function(cart){
      var lines=clubLines(cart),total=0;
      lines.forEach(function(l){total+=l.quantity;});
      if(total<=1)return false;
      var updates={};
      lines.forEach(function(l,i){updates[l.key]=i===0?1:0;});   // /cart.js lists the newest line first
      return orig.call(window,'/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({updates:updates})}).then(function(r){if(r.ok)rebuild(true);return r.ok;});
    }).catch(function(){return false;}).then(function(v){trimming=false;return v;});
  }

  window.fetch=function(input,init){
    try{
      var url=(typeof input==='string')?input:(input&&input.url)||'';
      var u=new URL(url,location.href);
      if(u.origin===location.origin&&/^\/cart\/add(\.js)?$/.test(u.pathname)&&init&&init.body){
        var b=null;
        if(typeof init.body==='string'){try{b=JSON.parse(init.body);}catch(_){b=null;}}
        if(!b||typeof b!=='object'){
          /* the page's own form (theme.js posts it urlencoded): its choices are the shopper's; only keep it one club */
          var fid=null;
          if(typeof init.body==='string')fid=new URLSearchParams(init.body).get('id');
          else if(typeof init.body.get==='function')fid=init.body.get('id');
          if(fid&&isClub(fid))return orig.apply(this,arguments).then(function(res){if(res&&res.ok)trimToOne();return res;});
          return orig.apply(this,arguments);
        }
        var list=Array.isArray(b.items)?b.items:(b.id!=null?[b]:[]);
        var clubs=list.filter(function(l){return l&&isClub(l.id);});
        if(clubs.length){
          var self=this;
          /* a cart we cannot read counts as empty: the add still goes, and a second club is trimmed later */
          return getCart().then(null,function(){return null;}).then(function(cart){
            var have=cart?clubLines(cart):[];
            var keep=have.length?[]:clubs.slice(0,1);         // one club per order
            keep.forEach(patchLine);
            var rest=list.filter(function(l){return !(l&&isClub(l.id))||keep.indexOf(l)>-1;});
            if(!rest.length){rebuild(true);return okResponse(have[0]);}   // already in the cart: show it, add nothing
            var body;
            if(Array.isArray(b.items)){b.items=rest;body=b;}else{body=rest[0];}
            var next={};for(var k in init){next[k]=init[k];}
            next.body=JSON.stringify(body);
            return orig.call(self,input,next).then(function(res){if(res&&res.ok)rebuild(true);return res;});
          });
        }
      }
    }catch(e){/* never break the cart over a default */}
    return orig.apply(this,arguments);
  };

  var busy=false;
  function changeLine(key,mutate,box){
    if(busy||!key)return;
    busy=true;if(box)box.setAttribute('aria-busy','true');
    getCart().then(function(cart){
      var line=null;(cart.items||[]).forEach(function(it){if(it.key===key)line=it;});
      if(!line)return null;
      var props={},src=line.properties||{};
      for(var k in src){if(Object.prototype.hasOwnProperty.call(src,k)&&src[k]!=null&&src[k]!=='')props[k]=src[k];}
      var before=JSON.stringify(props);
      mutate(props);
      if(!props._club)props._club='12mo';
      if(JSON.stringify(props)===before)return null;
      return orig.call(window,'/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:key,quantity:1,properties:props})});
    }).then(function(r){
      if(r&&!r.ok)throw 0;
      if(r)rebuild(false);
    }).catch(function(){
      rebuild(false);   // the line kept its old choices: redraw so the box shows what the cart really says
    }).then(function(){busy=false;if(box)box.removeAttribute('aria-busy');});
  }
  document.addEventListener('change',function(e){
    var t=e.target;if(!t||!t.closest)return;
    var box=t.closest('[data-casam-club-start]');if(!box)return;
    var key=box.getAttribute('data-key');
    if(t.type==='radio'&&t.checked){
      changeLine(key,function(p){p.Start=t.value;},box);
    }else if(t.type==='checkbox'&&t.hasAttribute('data-casam-club-gift')){
      var on=t.checked;
      changeLine(key,function(p){
        if(on){p.Gift='Yes';}else{delete p.Gift;delete p['Gift for'];delete p['Gift message'];}
      },box);
    }
  });

  /* The club line has no quantity control (one club per order), and the drawer hides .cart__remove in favour of the
     quantity minus, so the club line carries its own Remove. */
  document.addEventListener('click',function(e){
    var a=e.target&&e.target.closest&&e.target.closest('[data-casam-club-remove]');if(!a)return;
    e.preventDefault();
    var key=a.getAttribute('data-key');if(!key||busy)return;
    busy=true;
    orig.call(window,'/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key,quantity:0})}).then(function(){rebuild(false);},function(){rebuild(false);})
      .then(function(){busy=false;});
  });

  /* /cart renders its lines on the server: a /cart/add link with a quantity lands here */
  if(document.querySelector('[data-casam-club-start]'))trimToOne();
})();
